export const apiConfig = {
  // 为了方便接口封装，这里统一命名格式为【类型+ 'ApiUrl'】，注意：baseApiUrl 名称不可修改
  // baseApiUrl: 'http://192.168.0.38:8088/index.php/api/' // 项目接口地址
  // baseApiUrl: 'https://ruitu.zhongyoujingji.com/home.php/api/',
  baseApiUrl: 'https://www.gentle-emp.com/home.php/api/'
}
